import { Container, Row, Col, ListGroup, Button } from 'react-bootstrap'
import Link from 'next/link';

function EasyToRead () {
	
return (
<>
	<div className="vfl__EasyToRead bg-white text-dark py-4">
		<Container className="container">
            <h2 className="text-center py-5"><strong>In my short, easy to read newsletter you'll get:</strong></h2>
			<Row className="flex-column-reverse flex-lg-row">
				<Col lg={5} md={12}>
				<div className="text-center">
					<img className="img-fluid" src="../images/vfl/img-vitality-for-life-beauty-monitor.png" alt="Monitor" /><br />
				</div>
				</Col>
				<Col lg={7} md={12} className="pl-5 vfl__EasyToRead--checklist">
					<ListGroup>
						<ListGroup.Item className="border-0"><img className="tvc__check mr-3 img-fluid" src="../images/vfl/img-checkmark.png" alt="Check" />Links to what's new</ListGroup.Item>
						<ListGroup.Item className="border-0"><img className="tvc__check mr-3 img-fluid" src="../images/vfl/img-checkmark.png" alt="Check" />Updates on specials and promotions</ListGroup.Item>
						<ListGroup.Item className="border-0"><img className="tvc__check mr-3 img-fluid" src="../images/vfl/img-checkmark.png" alt="Check" />Tips for better health through natural nutrition</ListGroup.Item>
						<ListGroup.Item className="border-0"><img className="tvc__check mr-3 img-fluid" src="../images/vfl/img-checkmark.png" alt="Check" />Updates on the science behind Shaklee's products</ListGroup.Item>
						<ListGroup.Item className="border-0"><img className="tvc__check mr-3 img-fluid" src="../images/vfl/img-checkmark.png" alt="Check" />Great information shared by respected scientists, doctors and wellness experts</ListGroup.Item>
						<ListGroup.Item className="border-0"><img className="tvc__check mr-3 img-fluid" src="../images/vfl/img-checkmark.png" alt="Check" />Plus, much more!</ListGroup.Item>
					</ListGroup>
                    <Link href="/vitality-for-life-newsletter/confirmation">
						<Button variant="warning text-white font-weight-bold px-5 py-3 rounded-0 ml-5 my-3">SIGN UP</Button>
                    </Link>
				</Col>
			</Row>
		</Container>
	</div>
	<style jsx global>{`
		.vfl__EasyToRead .vfl__EasyToRead--checklist{
			padding-left:0px!important;
		}
		@media(max-width: 991px){
            .vfl__EasyToRead .container{
                max-width:100%!important;
		}
		.vfl__EasyToRead .btn{
			margin-left: 60px!important;
		}
		`}
	</style>
    <style jsx>{`
    
		`}
	</style>
</>
);
}
export default EasyToRead;